module.exports = __webpack_public_path__ + "static/three-scientists-and-their-gods-b222d5941304b1c95689a513ccf79cf2.jpg";